import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=17c25f7c&scoped=true&"
import script from "./demo.vue?vue&type=script&lang=js&"
export * from "./demo.vue?vue&type=script&lang=js&"
import style0 from "./demo.vue?vue&type=style&index=0&id=17c25f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c25f7c",
  null
  
)

export default component.exports